import React, { Component } from "react";
import NumberFormat from "react-number-format";
import Time from "react-time-format";
import { Select } from "antd";
import Swal from "sweetalert2";
import PropertyesList from "../../Propertys_Agent/PropertyesList";
import { isMobile } from "react-device-detect";
class ViewContractSell extends Component {
 constructor(props) {
  super(props);
  this.state = {
   lastPrice: 0,
   introduction: 0,
   firstname: "",
   secondname: "",
   duedate: "",
   lawman: "",
   fee: 0,
   reject: 0,
   save: null,
   Area: "",
   Property: "",
   NOoFProperty: "",
   phone1: 0,
   phone2: 0,
   Place_ku: "",
   pay_day: "",
   pay: 0,
   note: "",
   block: "",
   flour: "",
   metrPrice: "",
   Place_ar: "",
   Place_en: "",
   update_open: false,
   update_close: false,
   witness1: "",
   witness2: "",
   status: "active",
   createdAt: "",
   type: "",
   s_code: "",
   s_letter: "",
  };
 }
 componentDidUpdate(prevProps) {
  const { sell_invoice_obj } = this.props;
  if (prevProps.sell_invoice_obj !== sell_invoice_obj) {
   this.setState({
    lastPrice:
     sell_invoice_obj.lastPrice !== ""
      ? Number(
         parseFloat(sell_invoice_obj.lastPrice.toString().replace(/,/g, ""))
        )
      : 0,
    introduction:
     sell_invoice_obj.introduction !== ""
      ? Number(
         parseFloat(sell_invoice_obj.introduction.toString().replace(/,/g, ""))
        )
      : 0,
    firstname: sell_invoice_obj.firstname,
    secondname: sell_invoice_obj.secondname,
    duedate: sell_invoice_obj.duedate,
    lawman: sell_invoice_obj.lawman,
    fee:
     sell_invoice_obj.fee !== ""
      ? Number(parseFloat(sell_invoice_obj.fee.toString().replace(/,/g, "")))
      : 0,
    reject:
     sell_invoice_obj.reject !== ""
      ? Number(parseFloat(sell_invoice_obj.reject.toString().replace(/,/g, "")))
      : 0,
    Area: sell_invoice_obj.available_id
     ? sell_invoice_obj.available_id.Area
     : "",
    Property: sell_invoice_obj.available_id
     ? sell_invoice_obj.available_id.Property
     : "",
    NOoFProperty: sell_invoice_obj.available_id
     ? sell_invoice_obj.available_id.NOoFProperty
     : "",
    phone1: sell_invoice_obj.phone1,
    phone2: sell_invoice_obj.phone2,
    witness1: sell_invoice_obj.witness1,
    witness2: sell_invoice_obj.witness2,
    Place_ku:
     sell_invoice_obj.available_id && sell_invoice_obj.available_id.Place_ku,
    Place_ar:
     sell_invoice_obj.available_id && sell_invoice_obj.available_id.Place_ar,
    Place_en:
     sell_invoice_obj.available_id && sell_invoice_obj.available_id.Place_en,
    pay_day: sell_invoice_obj.pay_day,
    pay:
     sell_invoice_obj.pay !== ""
      ? Number(parseFloat(sell_invoice_obj.pay.toString().replace(/,/g, "")))
      : 0,
    note: sell_invoice_obj.note,
    block: sell_invoice_obj.available_id && sell_invoice_obj.available_id.block,
    flour: sell_invoice_obj.available_id && sell_invoice_obj.available_id.flour,
    metrPrice:
     sell_invoice_obj.available_id && sell_invoice_obj.available_id.metrPrice,
    type: sell_invoice_obj.type,
    status: sell_invoice_obj.status,
    createdAt: sell_invoice_obj.createdAt,
    update_close: true,
    s_code: sell_invoice_obj.s_code,
    s_letter: sell_invoice_obj.s_letter,
   });
  }
 }

 Sell_getPrint = () => {
  window.setTimeout("window.print()", 1000);
 };
 OnChangeHandler = (e) => {
  this.setState(
   {
    [e.target.name]: e.target.value,
   },
   () => {
    this.Kamkrdnawa();
   }
  );
 };
 onCloseUpdate = () => {
  const { Get_List_Sell_Contracts, onClose, Update_SellContract } = this.props;
  const data = {
   firstname: this.state.firstname,
   secondname: this.state.secondname,
   introduction:
    this.state.introduction !== ""
     ? parseFloat(this.state.introduction.toString().replace(/,/g, ""))
     : 0,
   lastPrice:
    this.state.lastPrice !== ""
     ? parseFloat(this.state.lastPrice.toString().replace(/,/g, ""))
     : 0,
   duedate: this.state.duedate,
   lawman: this.state.lawman,
   fee:
    this.state.fee !== ""
     ? parseFloat(this.state.fee.toString().replace(/,/g, ""))
     : 0,
   reject:
    this.state.reject !== ""
     ? parseFloat(this.state.reject.toString().replace(/,/g, ""))
     : 0,
   pay:
    this.state.pay !== ""
     ? parseFloat(this.state.pay.toString().replace(/,/g, ""))
     : 0,
   Area: this.state.Area,
   Property: this.state.Property,
   NOoFProperty: this.state.NOoFProperty,
   Place_ku: this.state.Place_ku,
   phone1: this.state.phone1 !== "" ? this.state.phone1 : 0,
   phone2: this.state.phone2 !== "" ? this.state.phone2 : 0,
   pay_day: this.state.pay_day,
   note: this.state.note,
   block: this.state.block,
   flour: this.state.flour,
   metrPrice: this.state.metrPrice,
   witness1: this.state.witness1,
   witness2: this.state.witness2,
   status: this.state.status,
   createdAt: this.state.createdAt,
   type: this.state.type,
   s_code: this.state.s_code,
   s_letter: this.state.s_letter,
  };
  if (
   this.state.firstname === "" ||
   this.state.secondname === "" ||
   this.state.lastPrice === "" ||
   this.state.lastPrice === 0 ||
   this.state.introduction === "" ||
   this.state.introduction === 0 ||
   this.state.Property.toString().length === 0
  ) {
   Swal.fire({
    title: "OPS",
    text: this.props.change_Lang("Please Check Inputs"),
    icon: "error",
    html: `<b class="fk">${this.props.change_Lang("Please Check Inputs")}</b>`,
    confirmButtonText: this.props.change_Lang("Ok"),
    buttonsStyling: { fontFamily: "fk" },
    timer: 1300,
   });
  } else {
   Swal.fire({
    title: "Good job!",
    html: `<b class="fk">${this.props.change_Lang(
     "You successfully tainted your work"
    )}</b>`,
    icon: "success",
    confirmButtonText: this.props.change_Lang("success"),
    buttonsStyling: { fontFamily: "fk" },
    timer: 1000,
   });
   Update_SellContract(this.props.sell_invoice_obj._id, data);
   this.setState({ update_close: true, update_open: false });
   onClose();
   setTimeout(() => {
    Get_List_Sell_Contracts();
   }, 2000);
  }
 };
 onOpenUpdate = () => {
  this.setState({ update_open: true, update_close: false });
 };

 Kamkrdnawa = () => {
  let x = Number(parseFloat(this.state.lastPrice.toString().replace(/,/g, "")));
  let y = Number(
   parseFloat(this.state.introduction.toString().replace(/,/g, ""))
  );
  let z = Number(parseFloat(this.state.pay.toString().replace(/,/g, "")));
  z =
   parseFloat(x.toString().replace(/,/g, "")) -
   parseFloat(y.toString().replace(/,/g, ""));
  this.setState({ pay: z });
 };
 handleChange_Property = (value) => {
  this.setState({ Property: value });
 };
 handleChange_Status = (value) => {
  this.setState({ status: value });
 };
 handleChange_Type = (value) => {
  this.setState({ type: value });
 };
 render() {
  const {
   lang,
   change_Lang,
   sell_invoice_obj,
   index_sell_contract,
   user,
   name_arb,
   name_en,
   name_krd,
  } = this.props;
  const {
   flour,
   block,
   note,
   pay,
   update_close,
   update_open,
   phone2,
   phone1,
   NOoFProperty,
   Property,
   Area,
   reject,
   fee,
   lawman,
   duedate,
   secondname,
   firstname,
   lastPrice,
   introduction,
   Place_ku,
   pay_day,
   status,
   createdAt,
   type,
   witness1,
   witness2,
   s_code,
   s_letter,
  } = this.state;
  const {
   onOpenUpdate,
   OnChangeHandler,
   onCloseUpdate,
   handleChange_Status,
   handleChange_Type,
  } = this;
  const { Option } = Select;
  return (
   <>
    <div
     className={`${lang === "en" ? "" : " fk"}`}
     style={{ overflowX: "hidden" }}
    >
     <div className="row">
      <div className="col-12">
       <div className="row p-3">
        <div className="col-md-4 text-right ">
         <p
          style={{
           fontSize: "18px",
           fontWeight: "bolder",
           color: "black",
          }}
          className={
           isMobile
            ? "d-flex justify-content-center"
            : "d-flex justify-content-start"
          }
         >
          {change_Lang("Company Branch")}: &nbsp;
          {sell_invoice_obj.branchId ? sell_invoice_obj.branchId.name : ""}
         </p>
        </div>
        <div className="col-md-4 d-flex justify-content-center">
         <p
          style={{
           fontSize: "18px",
           fontWeight: "bold",
           color: "black",
          }}
         >
          {change_Lang("contract number")} # {index_sell_contract}
         </p>
        </div>
        <div
         className={
          isMobile
           ? "col-md-4 d-flex justify-content-center"
           : "col-md-4 d-flex justify-content-end"
         }
        >
         <p
          style={{
           fontSize: "18px",
           fontWeight: "bold",
           color: "black",
          }}
         >
          {change_Lang("date")} &nbsp;
          {update_open !== true ? (
           <Time
            value={sell_invoice_obj.createdAt}
            format="YYYY-MM-DD"
            style={{ color: "black" }}
           />
          ) : (
           <label>
            <input
             type="date"
             value={createdAt}
             name="createdAt"
             onChange={OnChangeHandler}
             autoComplete="off"
             className="form-control fk text-center"
             style={{
              fontSize: "16px",
              borderBottomColor: "#3889c1",
             }}
            />
           </label>
          )}
         </p>
        </div>
       </div>
       <div className="row">
        <div className="col-md-12">
         <p
          style={{
           fontSize: "20px",
           color: "black",
           background: "#e3e9f2",
          }}
          className="mb-4 d-flex justify-content-center text-uppercase p-1"
         >
          {change_Lang("sale and purchase contract")}
         </p>
         {/* names */}
         <div className="form-group row form-inline">
          <label
           style={{ fontSize: "16px", color: "black" }}
           className={
            isMobile
             ? "col-sm-2 form-label d-flex justify-content-center"
             : " col-sm-2 form-label"
           }
          >
           {change_Lang("First Side")}:
          </label>
          <div
           className={
            isMobile
             ? "col-sm-3 form-label d-flex justify-content-center"
             : " col-sm-3 form-label"
           }
          >
           <label className="">
            {update_open !== true ? (
             firstname
            ) : (
             <input
              type="text"
              value={firstname}
              name="firstname"
              onChange={OnChangeHandler}
              autoComplete="off"
              className="form-control fk text-center"
              style={{
               fontSize: "16px",
               borderBottomColor: "#3889c1",
              }}
             />
            )}
           </label>
          </div>
          <label
           style={{ fontSize: "16px", color: "black" }}
           className={
            isMobile
             ? "col-sm-2 form-label d-flex justify-content-center"
             : " col-sm-2 form-label"
           }
          >
           {" "}
           {change_Lang("Second Side")}:
          </label>
          <div
           className={
            isMobile
             ? "col-sm-3 form-label d-flex justify-content-center"
             : " col-sm-3 form-label"
           }
          >
           <label className="">
            {update_open !== true ? (
             secondname
            ) : (
             <input
              type="text"
              value={secondname}
              name="secondname"
              onChange={OnChangeHandler}
              autoComplete="off"
              className="form-control fk text-center"
              style={{
               fontSize: "16px",
               borderBottomColor: "#3889c1",
              }}
             />
            )}
           </label>
          </div>
         </div>
         {/* phones */}
         <div className="form-group row form-inline">
          <label
           style={{ fontSize: "16px", color: "black" }}
           className={
            isMobile
             ? "col-sm-2 form-label d-flex justify-content-center"
             : " col-sm-2 form-label"
           }
          >
           {change_Lang("phone_number")}:
          </label>
          <div
           className={
            isMobile
             ? "col-sm-3 form-label d-flex justify-content-center"
             : " col-sm-3 form-label"
           }
          >
           <label className="">
            {update_open !== true ? (
             phone1
            ) : (
             <input
              type="text"
              value={phone1}
              name="phone1"
              onChange={OnChangeHandler}
              autoComplete="off"
              className="form-control fk text-center"
              style={{
               fontSize: "16px",
               borderBottomColor: "#3889c1",
              }}
             />
            )}
           </label>
          </div>
          <label
           style={{ fontSize: "16px", color: "black" }}
           className={
            isMobile
             ? "col-sm-2 form-label d-flex justify-content-center"
             : " col-sm-2 form-label"
           }
          >
           {" "}
           {change_Lang("phone_number")}:
          </label>
          <div
           className={
            isMobile
             ? "col-sm-3 form-label d-flex justify-content-center"
             : " col-sm-3 form-label"
           }
          >
           <label className="">
            {update_open !== true ? (
             phone2
            ) : (
             <input
              type="text"
              value={phone2}
              name="phone2"
              onChange={OnChangeHandler}
              autoComplete="off"
              className="form-control fk text-center"
              style={{
               fontSize: "16px",
               borderBottomColor: "#3889c1",
              }}
             />
            )}
           </label>
          </div>
         </div>
         {/* witness */}
         <div className="form-group row form-inline">
          <label
           style={{ fontSize: "16px", color: "black" }}
           className="col-sm-2 col-form-label"
          >
           {change_Lang("Witness")}:
          </label>
          <div className="col-sm-3">
           <label className="">
            {update_open !== true ? (
             witness1
            ) : (
             <input
              type="text"
              value={witness1}
              name="witness1"
              onChange={OnChangeHandler}
              autoComplete="off"
              className="form-control fk text-center"
              style={{
               fontSize: "16px",
               borderBottomColor: "#3889c1",
              }}
             />
            )}
           </label>
          </div>
          <label
           style={{ fontSize: "16px", color: "black" }}
           className="col-sm-2 col-form-label"
          >
           {" "}
           {change_Lang("Witness")}:
          </label>
          <div className="col-sm-3">
           <label className="">
            {update_open !== true ? (
             witness2
            ) : (
             <input
              type="text"
              value={witness2}
              name="witness2"
              onChange={OnChangeHandler}
              autoComplete="off"
              className="form-control fk text-center"
              style={{
               fontSize: "16px",
               borderBottomColor: "#3889c1",
              }}
             />
            )}
           </label>
          </div>
         </div>

         {/* second */}
         <div className="form-group row form-inline">
          <label
           style={{ fontSize: "16px", color: "black" }}
           className={
            isMobile
             ? "col-sm-2 form-label d-flex justify-content-center"
             : " col-sm-2 form-label"
           }
          >
           {change_Lang("first_rule_Property_type")}:
          </label>
          <div
           className={
            isMobile
             ? "col-sm-3 form-label d-flex justify-content-center"
             : " col-sm-3 form-label"
           }
          >
           <label className="">
            {update_open !== true ? (
             change_Lang(Property)
            ) : (
             <PropertyesList
              onChangeProperty={this.handleChange_Property}
              value={Property}
              defaultValue={change_Lang("Choose")}
              className="fk"
              size="large"
              style={{
               fontSize: "16px",
               borderBottomColor: "#ed3537",
               width: "196px",
              }}
             />
            )}
           </label>
          </div>
          <label
           style={{ fontSize: "16px", color: "black" }}
           className={
            isMobile
             ? "col-sm-2 form-label d-flex justify-content-center"
             : " col-sm-2 form-label"
           }
          >
           {" "}
           {change_Lang("The name of the neighborhood")}:
          </label>
          <div
           className={
            isMobile
             ? "col-sm-3 form-label d-flex justify-content-center"
             : " col-sm-3 form-label"
           }
          >
           <label className="">
            {update_open !== true ? (
             Place_ku
            ) : (
             <input
              type="text"
              value={Place_ku}
              name="Place_ku"
              onChange={OnChangeHandler}
              autoComplete="off"
              className="form-control fk text-center"
              style={{
               fontSize: "16px",
               borderBottomColor: "#3889c1",
              }}
             />
            )}
           </label>
          </div>
         </div>
         {/* Thisrd */}
         <div className="form-group row form-inline">
          <label
           style={{ fontSize: "16px", color: "black" }}
           className={
            isMobile
             ? "col-sm-2 form-label d-flex justify-content-center"
             : " col-sm-2 form-label"
           }
          >
           {change_Lang("Area")}:
          </label>
          <div
           className={
            isMobile
             ? "col-sm-3 form-label d-flex justify-content-center"
             : " col-sm-3 form-label"
           }
          >
           <label className="">
            {update_open !== true ? (
             Area
            ) : (
             <input
              type="text"
              value={Area}
              name="Area"
              onChange={OnChangeHandler}
              autoComplete="off"
              className="form-control fk text-center"
              style={{
               fontSize: "16px",
               borderBottomColor: "#3889c1",
              }}
             />
            )}
           </label>
          </div>
          <label
           style={{ fontSize: "16px", color: "black" }}
           className={
            isMobile
             ? "col-sm-2 form-label d-flex justify-content-center"
             : " col-sm-2 form-label"
           }
          >
           {change_Lang("Number")}:
          </label>
          <div
           className={
            isMobile
             ? "col-sm-3 form-label d-flex justify-content-center"
             : " col-sm-3 form-label"
           }
          >
           <label className="">
            {update_open !== true ? (
             NOoFProperty
            ) : (
             <input
              type="text"
              value={NOoFProperty}
              name="NOoFProperty"
              onChange={OnChangeHandler}
              autoComplete="off"
              className="form-control fk text-center"
              style={{
               fontSize: "16px",
               borderBottomColor: "#3889c1",
              }}
             />
            )}
           </label>
          </div>
         </div>
         {/* forth */}
         {/* {Property === "Apartment" ? (
                    <>
                      <div className="form-group row form-inline">
                        <label
                          style={{ fontSize: "16px", color: "black" }}
                          className={
                            isMobile
                              ? "col-sm-2 form-label d-flex justify-content-center"
                              : " col-sm-2 form-label"
                          }
                        >
                          {change_Lang("block")}:
                        </label>
                        <div
                          className={
                            isMobile
                              ? "col-sm-3 form-label d-flex justify-content-center"
                              : " col-sm-3 form-label"
                          }
                        >
                          <label className="">
                            {update_open !== true ? (
                              block
                            ) : (
                              <input
                                type="text"
                                value={block}
                                name="block"
                                onChange={OnChangeHandler}
                                autoComplete="off"
                                className="form-control fk text-center"
                                style={{
                                  fontSize: "16px",
                                  borderBottomColor: "#3889c1",
                                }}
                              />
                            )}
                          </label>
                        </div>
                        <label
                          style={{ fontSize: "16px", color: "black" }}
                          className={
                            isMobile
                              ? "col-sm-2 form-label d-flex justify-content-center"
                              : " col-sm-2 form-label"
                          }
                        >
                          {" "}
                          {change_Lang("flour")}:
                        </label>
                        <div
                          className={
                            isMobile
                              ? "col-sm-3 form-label d-flex justify-content-center"
                              : " col-sm-3 form-label"
                          }
                        >
                          <label className="">
                            {update_open !== true ? (
                              flour
                            ) : (
                              <input
                                type="text"
                                value={flour}
                                name="flour"
                                onChange={OnChangeHandler}
                                autoComplete="off"
                                className="form-control fk text-center"
                                style={{
                                  fontSize: "16px",
                                  borderBottomColor: "#3889c1",
                                }}
                              />
                            )}
                          </label>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )} */}
         {/* </div> */}
         <div className="form-group row form-inline">
          <label
           style={{ fontSize: "16px", color: "black" }}
           className={
            isMobile
             ? "col-sm-2 form-label d-flex justify-content-center"
             : " col-sm-2 form-label"
           }
          >
           {change_Lang("type of contract")}:
          </label>
          <div
           className={
            isMobile
             ? "col-sm-3 form-label d-flex justify-content-center"
             : " col-sm-3 form-label"
           }
          >
           <label className="">
            {update_open !== true ? (
             change_Lang(status)
            ) : (
             <Select
              onChange={handleChange_Status}
              value={status}
              defaultValue={change_Lang("Choose")}
              size="large"
              style={{
               fontSize: "16px",
               borderBottomColor: "#000000",
               width: "196px",
              }}
              className="fk text-center"
             >
              <Option value="" className="fk">
               {change_Lang("Choose")}
              </Option>
              <Option className="fk" value={"active"}>
               {change_Lang("active")}
              </Option>
              <Option className="fk" value={"Rejected"}>
               {change_Lang("Rejected")}
              </Option>
             </Select>
            )}
           </label>
          </div>
          <label
           style={{ fontSize: "16px", color: "black" }}
           className={
            isMobile
             ? "col-sm-2 form-label d-flex justify-content-center"
             : " col-sm-2 form-label"
           }
          >
           {/* {change_Lang("type")}: */}
          </label>
          <div
           className={
            isMobile
             ? "col-sm-3 form-label d-flex justify-content-center"
             : " col-sm-3 form-label"
           }
          >
           {/* <label className="">
                        {update_open !== true ? (
                          type
                        ) : (
                          <Select
                            onChange={handleChange_Type}
                            value={type}
                            size="large"
                            style={{
                              fontSize: "16px",
                              borderBottomColor: "#000000",
                              width: "196px",
                            }}
                            className="fk text-center"
                          >
                            <Option value={""}>{change_Lang("type")}</Option>
                            <Option value={"studio"}>studio</Option>
                            <Option value={"0+1"}>0+1</Option>
                            <Option value={"1+1"}>1+1</Option>
                            <Option value={"2+1"}>2+1</Option>
                            <Option value={"3+1"}>3+1</Option>
                            <Option value={"4+1"}>4+1</Option>
                          </Select>
                        )}
                      </label> */}
          </div>
         </div>
         {/* codes */}
         <div className="form-group row form-inline">
          <label
           style={{ fontSize: "16px", color: "black" }}
           className={
            isMobile
             ? "col-sm-2 form-label d-flex justify-content-center"
             : " col-sm-2 form-label"
           }
          >
           {change_Lang("Code Number")}:
          </label>
          <div
           className={
            isMobile
             ? "col-sm-3 form-label d-flex justify-content-center"
             : " col-sm-3 form-label"
           }
          >
           <label className="">
            {update_open !== true ? (
             s_code
            ) : (
             <input
              type="text"
              value={s_code}
              name="s_code"
              onChange={OnChangeHandler}
              autoComplete="off"
              className="form-control fk text-center"
              style={{
               fontSize: "16px",
               borderBottomColor: "#3889c1",
              }}
             />
            )}
           </label>
          </div>
          <label
           style={{ fontSize: "16px", color: "black" }}
           className={
            isMobile
             ? "col-sm-2 form-label d-flex justify-content-center"
             : " col-sm-2 form-label"
           }
          >
           {" "}
           {change_Lang("Code Letter")}:
          </label>
          <div
           className={
            isMobile
             ? "col-sm-3 form-label d-flex justify-content-center"
             : " col-sm-3 form-label"
           }
          >
           <label className="">
            {update_open !== true ? (
             s_letter
            ) : (
             <input
              type="text"
              value={s_letter}
              name="s_letter"
              onChange={OnChangeHandler}
              autoComplete="off"
              className="form-control fk text-center"
              style={{
               fontSize: "16px",
               borderBottomColor: "#3889c1",
              }}
             />
            )}
           </label>
          </div>
         </div>
         <br />
         <hr />
         <p
          style={{ fontSize: "18px", color: "black" }}
          className="mb-1 d-flex justify-content-center"
         >
          {change_Lang("agreement")}
         </p>
        </div>
       </div>
       <div className="row ">
        <div className="col-md-12">
         <table className="table">
          <tbody>
           <tr style={{ background: "#e3e9f2" }}>
            <td>1</td>
            <td
             style={{
              lineHeight: "1.8",
              wordSpacing: "5px",
             }}
            >
             {change_Lang("first_rule_price")}
             &nbsp;&nbsp;
             <NumberFormat
              displayType={`${update_open !== true ? "text" : "input"}`}
              thousandSeparator={true}
              value={lastPrice}
              name="lastPrice"
              onChange={OnChangeHandler}
              required
              className="text-center"
              prefix={`${update_open !== true ? "$" : ""}`}
             />
             &nbsp;&nbsp;
             {""}
             {change_Lang("first_rule_Property_type")} &nbsp;&nbsp;
             {change_Lang(Property)}
             &nbsp;&nbsp; {change_Lang("Number")} &nbsp;&nbsp;
             {NOoFProperty}
             &nbsp;&nbsp; {change_Lang("first_rule_place")} &nbsp;&nbsp;
             {Place_ku}
             &nbsp;&nbsp;
             {change_Lang("Area")}
             &nbsp;&nbsp;
             {Area} m<sup>2</sup>
             &nbsp;&nbsp;
            </td>
           </tr>
           <tr>
            <td>2</td>
            <td
             style={{
              lineHeight: "1.8",
              wordSpacing: "5px",
             }}
            >
             {change_Lang("second_rule_price")}
             &nbsp;&nbsp;
             <NumberFormat
              displayType={`${update_open !== true ? "text" : "input"}`}
              thousandSeparator={true}
              name="lastPrice"
              onChange={OnChangeHandler}
              value={lastPrice}
              className="text-center"
              prefix={`${update_open !== true ? "$" : ""}`}
             />
            </td>
           </tr>
           <tr style={{ background: "#e3e9f2" }}>
            <td>3</td>
            <td
             style={{
              lineHeight: "1.8",
              wordSpacing: "5px",
             }}
            >
             {change_Lang("S_balav_3_1")}
             &nbsp;&nbsp;
             <NumberFormat
              displayType={`${update_open !== true ? "text" : "input"}`}
              thousandSeparator={true}
              value={introduction}
              name="introduction"
              onChange={OnChangeHandler}
              required
              className="text-center"
              prefix={`${update_open !== true ? "$" : ""}`}
             />
             &nbsp;&nbsp;
             {change_Lang("S_balav_3_2")}
             &nbsp;&nbsp;
             {lang === "krd"
              ? "وە بڕی پارەی ماوە کە بڕی"
              : lang === "arb"
              ? "و المبلغ المتبقي"
              : "and The remaining amount"}
             &nbsp;(
             <NumberFormat
              displayType={`${update_open !== true ? "text" : "input"}`}
              thousandSeparator={true}
              value={pay}
              className="text-center"
              prefix={`${update_open !== true ? "$" : ""}`}
             />{" "}
             )&nbsp;{" "}
             {lang === "krd"
              ? "پێویستە رادەستی بکات لەبەرواری"
              : lang === "arb"
              ? "عليه أن يسلمها في التاريخ"
              : "must be pay on the date"}
             &nbsp;({" "}
             <label>
              {" "}
              {update_close !== false ? (
               <Time
                value={pay_day}
                format="YYYY-MM-DD"
                style={{
                 fontSize: "16px",
                 color: "black",
                 fontWeight: "normal",
                }}
               />
              ) : (
               <input
                value={pay_day}
                name="pay_day"
                onChange={OnChangeHandler}
                type="date"
                className="form-control fk text-center"
                style={{
                 fontSize: "16px",
                 borderBottomColor: "#3889c1",
                }}
               />
              )}
             </label>
             )&nbsp;{" "}
             {lang === "krd"
              ? "بەشێوەی (کاش-قسط)"
              : lang === "arb"
              ? "بطريقة ما (کاش-قسط)"
              : "cash or installment"}
             .
            </td>
           </tr>

           <tr>
            <td>4</td>
            <td
             style={{
              lineHeight: "1.8",
              wordSpacing: "5px",
             }}
            >
             {change_Lang("S_balav_5")}{" "}
             <label>
              {update_close !== false ? (
               <Time
                value={duedate}
                format="YYYY-MM-DD"
                style={{
                 fontSize: "16px",
                 color: "black",
                 fontWeight: "normal",
                }}
               />
              ) : (
               <input
                value={duedate}
                name="duedate"
                onChange={OnChangeHandler}
                type="date"
                className="form-control fk text-center"
                style={{
                 fontSize: "16px",
                 borderBottomColor: "#3889c1",
                }}
               />
              )}
             </label>
            </td>
           </tr>
           <tr style={{ background: "#e3e9f2" }}>
            <td>5</td>
            <td
             style={{
              lineHeight: "1.8",
              wordSpacing: "5px",
             }}
            >
             {change_Lang("fifth_rule_price")} &nbsp;&nbsp;
             <NumberFormat
              displayType={`${update_open !== true ? "text" : "input"}`}
              thousandSeparator={true}
              value={reject}
              name="reject"
              onChange={OnChangeHandler}
              required
              className="text-center"
              prefix={`${update_open !== true ? "$" : ""}`}
             />
             &nbsp;&nbsp;{change_Lang("fee")}
            </td>
           </tr>
           <tr>
            <td>6</td>
            <td
             style={{
              lineHeight: "1.8",
              wordSpacing: "5px",
             }}
            >
             {change_Lang("S_balav_7")}
            </td>
           </tr>
           <tr style={{ background: "#e3e9f2" }}>
            <td>7</td>
            <td
             style={{
              lineHeight: "1.8",
              wordSpacing: "5px",
             }}
            >
             {change_Lang("S_balav_8")}
             &nbsp;&nbsp;
             <NumberFormat
              displayType={`${update_open !== true ? "text" : "input"}`}
              thousandSeparator={true}
              value={fee}
              name="fee"
              onChange={OnChangeHandler}
              required
              className="text-center"
              prefix={`${update_open !== true ? "$" : ""}`}
             />
             &nbsp;&nbsp;
            </td>
           </tr>
           <tr>
            <td>8</td>
            <td
             style={{
              lineHeight: "1.8",
              wordSpacing: "5px",
              color: "black",
             }}
            >
             {change_Lang("S_balav_10")}{" "}
            </td>
           </tr>
           <tr style={{ background: "#e3e9f2" }}>
            <td>9</td>
            <td
             style={{
              lineHeight: "1.8",
              wordSpacing: "5px",
              color: "black",
             }}
            >
             {change_Lang("S_balav_11")}{" "}
            </td>
           </tr>
           <tr>
            <td>10</td>
            <td
             style={{
              lineHeight: "1.8",
              wordSpacing: "5px",
             }}
            >
             {change_Lang("S_balav_12_1")} &nbsp;
             <label className="text-center">
              {update_open !== true ? (
               lawman
              ) : (
               <input
                type="text"
                className="form-control fk text-center"
                value={lawman}
                name="lawman"
                onChange={OnChangeHandler}
                autoComplete="off"
                style={{
                 fontSize: "16px",
                 borderBottomColor: "#3889c1",
                }}
               />
              )}
             </label>
             &nbsp;
             {change_Lang("S_balav_12_2")}
             {}
            </td>
           </tr>
           <tr style={{ background: "#e3e9f2" }}>
            <td>11</td>
            <td
             style={{
              lineHeight: "1.8",
              wordSpacing: "5px",
              color: "black",
             }}
            >
             {lang == "krd" ? (
              <>
               لایەنی یەکەم وە لایەنی دووەم پابەند دەبێ بە پێدانی رێژەی %1
               لەنرخی موڵکی ئاماژەپێکراو لەم گرێبەستە لەبەرامبەر فرۆشتنی ئەم
               موڵکە بۆ ڕێکخەر .
              </>
             ) : lang == "arb" ? (
              <>
               يتعهد الطرف الأول بدفع نسبة 1% من سعر العقار المذكور في هذا العقد
               إلى {name_arb}&nbsp; إزاء بيع العقار .
              </>
             ) : (
              <>
               The first side and the second side undertakes to pay 1% of the
               price of the property mentioned in this contract to the&nbsp;
               {name_en} for the sale of the property.
              </>
             )}
            </td>
           </tr>
           <tr>
            <td>12</td>
            <td
             style={{
              lineHeight: "1.8",
              wordSpacing: "5px",
              color: "black",
             }}
            >
             {change_Lang("S_balav_15")}
            </td>
           </tr>
           {lang === "krd" ? (
            <>
             <tr style={{ background: "#e3e9f2" }}>
              <td>13</td>
              <td
               style={{
                lineHeight: "1.8",
                wordSpacing: "5px",
                color: "black",
               }}
              >
               لایەنی یەکەم وە لایەنی دووەم دوای واژوو کردنی گرێبەست مافی
               داواکردنی عمولەی پێدراویان نی یە .
              </td>
             </tr>
            </>
           ) : (
            ""
           )}
          </tbody>
         </table>
        </div>
       </div>
       <hr />
       <br />
       <div className="form-inline">
        <label
         style={{
          fontSize: "18px",
          fontWeight: "bolder",
          color: "black",
         }}
         className="form-label d-flex justify-content-start"
        >
         {change_Lang("note")}&nbsp;:
        </label>
        &nbsp;&nbsp;&nbsp;
        <label
         style={{
          fontSize: "16px",
          color: "black",
          fontWeight: "bold",
          textAlign: "justify",
         }}
         className="form-label d-flex justify-content-start"
        >
         {update_open !== true ? (
          <textarea
           value={note}
           autoComplete="off"
           className="form-control fk"
           style={{
            fontSize: "16px",
            border: "none",
           }}
           rows={5}
           cols={130}
          ></textarea>
         ) : (
          <textarea
           type="text"
           value={note}
           name="note"
           onChange={OnChangeHandler}
           autoComplete="off"
           className="form-control fk"
           style={{
            fontSize: "16px",
            borderBottomColor: "#3889c1",
           }}
           rows={5}
           cols={130}
          ></textarea>
         )}
        </label>
       </div>
       {/* Footer */}
       <div className="row">
        <div className="form-group d-flex justify-content-center col-md-6">
         <label
          style={{
           fontSize: "18px",
           fontWeight: "bolder",
           color: "black",
           alignItems: "center",
          }}
          className="form-label"
         >
          {change_Lang("First Party (Seller)")}
         </label>
        </div>
        <div className="col-md-6 d-flex justify-content-center">
         <div className="form-group ">
          <label
           style={{
            fontSize: "18px",
            fontWeight: "bolder",
            color: "black",
            alignItems: "center",
           }}
           className="form-label"
          >
           {change_Lang("Second Party (Buyer)")}
          </label>
         </div>
        </div>
       </div>
       <div className="row">
        <div className="col-md-6 form-group d-flex justify-content-center">
         <label
          style={{
           fontSize: "18px",
           fontWeight: "bolder",
           color: "black",
           alignItems: "center",
          }}
          className="form-label"
         >
          {firstname}
         </label>
        </div>
        <div className="col-md-6 d-flex justify-content-center">
         <div className="form-group ">
          <label
           style={{
            fontSize: "18px",
            fontWeight: "bolder",
            color: "black",
            alignItems: "center",
           }}
           className="form-label"
          >
           {secondname}
          </label>
         </div>
        </div>
       </div>
       <br />
       {/* Footer */}
       <div className="row">
        <div className="form-group d-flex justify-content-center col-md-12">
         <label
          style={{
           fontSize: "18px",
           fontWeight: "bolder",
           color: "black",
           alignItems: "center",
          }}
          className="form-label"
         >
          {lang === "krd"
           ? `( ب- ${name_krd} )`
           : lang === "arb"
           ? `منظم العقد/ ${name_arb}`
           : `Contract organizer /${name_en}`}
         </label>
        </div>
       </div>
       {/* Footer */}
       <div className="row">
        <div className="form-group d-flex justify-content-center col-md-12">
         <label
          style={{
           fontSize: "18px",
           fontWeight: "bolder",
           color: "black",
           alignItems: "center",
          }}
          className="form-label"
         >
          {`${sell_invoice_obj.agentId ? sell_invoice_obj.agentId.fname : ""} ${
           sell_invoice_obj.agentId ? sell_invoice_obj.agentId.lname : ""
          }`}
         </label>
        </div>
       </div>
       {user.u_contract !== false ? (
        <div
         className="d-flex flex-row-reverse text-white p-4"
         style={{ background: "#e3e9f2" }}
        >
         <div className="py-3 px-5 text-right">
          {update_close !== false ? (
           <button onClick={onOpenUpdate} className="btn btn-primary">
            {change_Lang("profile_updatebt")}
            &nbsp;&nbsp;&nbsp;
            <i style={{ fontSize: "18px" }} className="fa fa-lock"></i>
           </button>
          ) : (
           <button onClick={onCloseUpdate} className="btn btn-primary">
            {change_Lang("profile_updatebt")}
            &nbsp;&nbsp;&nbsp;
            <i style={{ fontSize: "18px" }} className="fa fa-lock-open"></i>
           </button>
          )}
         </div>
        </div>
       ) : (
        ""
       )}
      </div>
     </div>
    </div>
   </>
  );
 }
}

export default ViewContractSell;
